import { render, staticRenderFns } from "./Bottombox.vue?vue&type=template&id=0f913e63&scoped=true&"
import script from "./Bottombox.vue?vue&type=script&lang=js&"
export * from "./Bottombox.vue?vue&type=script&lang=js&"
import style0 from "./Bottombox.vue?vue&type=style&index=0&id=0f913e63&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f913e63",
  null
  
)

export default component.exports